import {
  I2cInput,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTooltip,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import style from "./csd.module.scss";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import "../Prepaid.scss";
export const consumerChannel = [
  { label: "C-Cart - Online Card Sales/Enrollment", value: 0 },
  {
    label: "C-Cart - Mobile App Card Sales/Enrollment",
    value: 1,
  },
  { label: "Cardholder Website (C-Holder)", value: 2 },
  { label: "C-Holder Mobile Application (Native)", value: 3 },
  { label: "C-Touch - Interactive Voice Response - IVR", value: 4 },
  { label: "Customer Services - Live Operator", value: 5 },
  { label: "Other", value: 6 },
];
export const credit_consumerChannel = [
  { label: "C-Holder Website (Card Management Website)", value: 0 },
  {
    label: "C-Holder Mobile Application (Native iOS and Android)",
    value: 1,
  },
  { label: "C-Cart (Self Service Enrollment Portal)", value: 2 },
  { label: "C-Touch (IVR – Interactive Voice Response)", value: 3 },
  // { label: "C-Touch - Interactive Voice Response - IVR", value: 4 },
  { label: "Live Operator (Contact Center Service)", value: 5 },
  { label: "Other", value: 6 },
];
export const merchantChannel = [
  { label: "C-Partner Portal (Bulk card ordering interface)", value: 0 },
  { label: "WebPOS - Web-based Point-of-Sale Portal", value: 1 },
  { label: "Other", value: 2 },
];
export const credit_merchantChannel = [
  { label: "C-Partner Portal (Bulk card ordering interface)", value: 0 },
  { label: "Other", value: 1 },
];
export const otherChannel = [
  { label: "Web Services API (VPN required)", value: 0 },
  { label: "Communication Link", value: 1 },
  { label: "Fastsettle (Settlement & Reconciliation)", value: 2 },
  { label: "Other", value: 3 },
];

export const credit_otherChannel = [
  { label: "Web Services API (VPN required)", value: 0 },
  { label: "Fastsettle (Settlement & Reconciliation)", value: 1 },
  { label: "Other", value: 2 },
];
const IndexContent = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const handleCheckboxGroupChange = (event, fieldName) => {
    let selectedValue;
    if (isNaN(event)) selectedValue = event.target.value;
    else selectedValue = event;
    const preSelected = methods.getValues(fieldName) ?? [];
    let updatedValues = [...preSelected];
    if (updatedValues.includes(selectedValue)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValue);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValue);
    }
    if (fieldName === "c_gi_consumer_channels" && !updatedValues.includes(6)) {
      methods.setValue("c_gi_consumer_channel_other", "");
    } else if (
      fieldName === "c_gi_stakeholder_channels" &&
      type === "credit" &&
      !updatedValues.includes(1)
    ) {
      methods.setValue("c_gi_stakeholder_channel_other", "");
    } else if (
      fieldName === "c_gi_stakeholder_channels" &&
      type !== "credit" &&
      !updatedValues.includes(2)
    ) {
      methods.setValue("c_gi_stakeholder_channel_other", "");
    } else if (
      fieldName === "c_gi_other_channels" &&
      type === "credit" &&
      !updatedValues.includes(2)
    ) {
      methods.setValue("c_gi_other_channel_other", "");
    } else if (
      fieldName === "c_gi_other_channels" &&
      type !== "credit" &&
      !updatedValues.includes(3)
    ) {
      methods.setValue("c_gi_other_channel_other", "");
    }

    const payload = updatedValues.filter((val) => !isNaN(val));
    methods.setValue(fieldName, payload);
    methods.trigger();
    handleValueChanges();
  };

  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    c_gi_consumer_channels: Yup.array()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    c_gi_consumer_channel_other: Yup.string().when("c_gi_consumer_channels", {
      is: (consumerChannels) => consumerChannels.includes(6),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    c_gi_stakeholder_channels: Yup.array()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    c_gi_stakeholder_channel_other: Yup.string().when(
      "c_gi_stakeholder_channels",
      {
        is: (consumerChannels) =>
          type === "credit"
            ? consumerChannels.includes(1)
            : consumerChannels.includes(2),
        then: () =>
          Yup.string()
            .required(generalErrorMessage)
            .min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
      },
    ),
    c_gi_other_channels: Yup.array()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    c_gi_other_channel_other: Yup.string().when("c_gi_other_channels", {
      is: (consumerChannels) =>
        type === "credit"
          ? consumerChannels.includes(2)
          : consumerChannels.includes(3),
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      c_gi_consumer_channels: [],
      c_gi_consumer_channel_other: "",
      c_gi_stakeholder_channels: [],
      c_gi_stakeholder_channel_other: "",
      c_gi_other_channels: [],
      c_gi_other_channel_other: "",
    },
  });

  const fields = [
    "c_gi_consumer_channels",
    "c_gi_consumer_channel_other",
    "c_gi_stakeholder_channels",
    "c_gi_stakeholder_channel_other",
    "c_gi_other_channels",
    "c_gi_other_channel_other",
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[4]["4_0"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      4: {
        ...addFormData["4"],
        "4_0": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("4_0", true);
    else setFormValidStates("4_0", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="inner_step_title mb-24">General Information</div>
        <div i2c-grid="grid gap-sm" className="section-space">
          {/* <div i2c-grid="12">
            <div className="main-heading mb-8">General Information</div>
          </div> */}
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip mb-16">
              <div className="sub-heading">Cardholder/Consumer Channels</div>
              <I2cTooltip
                content="Additional setup and monthly minimum may apply"
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
            <div className="single-field-wrapper">
              <Controller
                name="c_gi_consumer_channels"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup {...field} >
                      <div i2c-grid="grid gap-sm">
                        {type === "credit" ? (
                          <>
                            {credit_consumerChannel.map((app, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={app.label}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("c_gi_consumer_channels")
                                  .includes(app.value)}
                                onI2cCheckboxClicked={() => {
                                  handleCheckboxGroupChange(
                                    app.value,
                                    field.name,
                                  );
                                }}
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  value={app.value}
                                  label=""
                                  filled
                                  className="customCheckbox"
                                  checked={methods
                                    .watch("c_gi_consumer_channels")
                                    .includes(app.value)}
                                  // onI2cChange={() => {
                                  //   handleCheckboxGroupChange(
                                  //     app.value,
                                  //     field.name,
                                  //   );
                                  // }}
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </>
                        ) : (
                          <>
                            {consumerChannel.map((app, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={app.label}
                                sublabel=""
                                value=""
                                checked={methods
                                  .watch("c_gi_consumer_channels")
                                  .includes(app.value)}
                                onI2cCheckboxClicked={() => {
                                  handleCheckboxGroupChange(
                                    app.value,
                                    field.name,
                                  );
                                }}
                                type="checkbox"
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  value={app.value}
                                  label=""
                                  filled
                                  className="customCheckbox"
                                  checked={methods
                                    .watch("c_gi_consumer_channels")
                                    .includes(app.value)}
                                  // onI2cChange={() => {
                                  //   handleCheckboxGroupChange(
                                  //     app.value,
                                  //     field.name,
                                  //   );
                                  // }}
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </>
                        )}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.c_gi_consumer_channels &&
                        methods.formState.touchedFields.c_gi_consumer_channels
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_consumer_channels?.message ??
                        "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          {methods.watch("c_gi_consumer_channels").includes(6) && (
            <div i2c-grid="12">
              <div className="single-field-wrapper">
                <Controller
                  name="c_gi_consumer_channel_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={style.halfWidth + " single-input-field"}
                      required
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                        methods.trigger();
                      }}
                      size="large"
                      label="Please Specify"
                      name={"c_gi_consumer_channel_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.c_gi_consumer_channel_other &&
                    methods.formState.touchedFields.c_gi_consumer_channel_other
                      ? true
                      : false
                  }
                  message={
                    errors.c_gi_consumer_channel_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip mb-16">
              <div className="sub-heading">Merchant/Stakeholder Channels</div>
              <I2cTooltip
                content="Additional setup and monthly minimum may apply"
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
            <div className="single-field-wrapper">
              <Controller
                name="c_gi_stakeholder_channels"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      {...field}
                      onI2cChange={(e) =>
                        handleCheckboxGroupChange(e, field.name)
                      }
                    >
                      <div i2c-grid="grid gap-sm">
                        {type === "credit" ? (
                          <>
                            {credit_merchantChannel.map((app, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={app.label}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("c_gi_stakeholder_channels")
                                  .includes(app.value)}
                                onI2cCheckboxClicked={() => {
                                  handleCheckboxGroupChange(
                                    app.value,
                                    field.name,
                                  );
                                }}
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  value={app.value}
                                  label=""
                                  filled
                                  className="customCheckbox"
                                  checked={methods
                                    .watch("c_gi_stakeholder_channels")
                                    .includes(app.value)}
                                  onI2cChange={() => {
                                    handleCheckboxGroupChange(
                                      app.value,
                                      field.name,
                                    );
                                  }}
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </>
                        ) : (
                          <>
                            {merchantChannel.map((app, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={app.label}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("c_gi_stakeholder_channels")
                                  .includes(app.value)}
                                onI2cCheckboxClicked={() => {
                                  handleCheckboxGroupChange(
                                    app.value,
                                    field.name,
                                  );
                                }}
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  value={app.value}
                                  label=""
                                  filled
                                  className="customCheckbox"
                                  checked={methods
                                    .watch("c_gi_stakeholder_channels")
                                    .includes(app.value)}
                                  onI2cChange={() => {
                                    handleCheckboxGroupChange(
                                      app.value,
                                      field.name,
                                    );
                                  }}
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </>
                        )}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.c_gi_stakeholder_channels &&
                        methods.formState.touchedFields
                          .c_gi_stakeholder_channels
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_stakeholder_channels?.message ??
                        "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          {type !== "credit"
            ? methods.watch("c_gi_stakeholder_channels").includes(2) && (
                <div i2c-grid="12">
                  <div className="single-field-wrapper">
                    <Controller
                      name="c_gi_stakeholder_channel_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className={style.halfWidth + " single-input-field"}
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                            methods.trigger();
                          }}
                          size="large"
                          label="Please Specify"
                          name={"c_gi_stakeholder_channel_other"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.c_gi_stakeholder_channel_other &&
                        methods.formState.touchedFields
                          .c_gi_stakeholder_channel_other
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_stakeholder_channel_other?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              )
            : methods.watch("c_gi_stakeholder_channels").includes(1) && (
                <div i2c-grid="12">
                  <div className="single-field-wrapper">
                    <Controller
                      name="c_gi_stakeholder_channel_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className={style.halfWidth + " single-input-field"}
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                            methods.trigger();
                          }}
                          size="large"
                          label="Please Specify"
                          name={"c_gi_stakeholder_channel_other"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.c_gi_stakeholder_channel_other &&
                        methods.formState.touchedFields
                          .c_gi_stakeholder_channel_other
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_stakeholder_channel_other?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              )}
        </div>
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip mb-16">
              <div className="sub-heading">Other Channels</div>
              <I2cTooltip
                content="Additional setup and monthly minimum may apply"
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
            <div className="single-field-wrapper">
              <Controller
                name="c_gi_other_channels"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      {...field}
                      onI2cChange={(e) =>
                        handleCheckboxGroupChange(e, field.name)
                      }
                    >
                      <div i2c-grid="grid gap-sm">
                        {type === "credit" ? (
                          <>
                            {credit_otherChannel.map((app, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={app.label}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("c_gi_other_channels")
                                  .includes(app.value)}
                                onI2cCheckboxClicked={() => {
                                  handleCheckboxGroupChange(
                                    app.value,
                                    field.name,
                                  );
                                }}
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  value={app.value}
                                  label=""
                                  filled
                                  className="customCheckbox"
                                  checked={methods
                                    .watch("c_gi_other_channels")
                                    .includes(app.value)}
                                  onI2cChange={() => {
                                    handleCheckboxGroupChange(
                                      app.value,
                                      field.name,
                                    );
                                  }}
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </>
                        ) : (
                          <>
                            {otherChannel.map((app, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={app.label}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("c_gi_other_channels")
                                  .includes(app.value)}
                                onI2cCheckboxClicked={() => {
                                  handleCheckboxGroupChange(
                                    app.value,
                                    field.name,
                                  );
                                }}
                              >
                                <I2cCheckbox
                                  slot="prefix"
                                  value={app.value}
                                  label=""
                                  filled
                                  className="customCheckbox"
                                  checked={methods
                                    .watch("c_gi_other_channels")
                                    .includes(app.value)}
                                  onI2cChange={() => {
                                    handleCheckboxGroupChange(
                                      app.value,
                                      field.name,
                                    );
                                  }}
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </>
                        )}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.c_gi_other_channels &&
                        methods.formState.touchedFields.c_gi_other_channels
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_other_channels?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          {type !== "credit"
            ? methods.watch("c_gi_other_channels").includes(3) && (
                <div i2c-grid="12">
                  <div className="single-field-wrapper">
                    <Controller
                      name="c_gi_other_channel_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className={style.halfWidth + " single-input-field"}
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                            methods.trigger();
                            // if (value.length === 0)
                            // 	methods.setError("c_gi_other_channel_other", {
                            // 		message: generalErrorMessage,
                            // 	});
                          }}
                          size="large"
                          label="Please Specify"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.c_gi_other_channel_other &&
                        methods.formState.touchedFields.c_gi_other_channel_other
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_other_channel_other?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              )
            : methods.watch("c_gi_other_channels").includes(2) && (
                <div i2c-grid="12">
                  <div className="single-field-wrapper">
                    <Controller
                      name="c_gi_other_channel_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className={style.halfWidth + " single-input-field"}
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                            methods.trigger();
                            // if (value.length === 0)
                            // 	methods.setError("c_gi_other_channel_other", {
                            // 		message: generalErrorMessage,
                            // 	});
                          }}
                          size="large"
                          label="Please Specify"
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.c_gi_other_channel_other &&
                        methods.formState.touchedFields.c_gi_other_channel_other
                          ? true
                          : false
                      }
                      message={
                        errors.c_gi_other_channel_other?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default IndexContent;
